import {
  ScreenStatus,
  SCREEEN_STATUS_CD,
} from "../../models/screen-status";

export default {
  namespaced: true,

  state: {
    screenStatus: new ScreenStatus(),
    notificationFlags: {
      singIn: false,
      signUp: false,
      resetPassword: false,
      deleteMonitoringTarget: false,
      deleteMonitoringDevice: false,
    },
    lastAccessDate: null,
  },

  mutations: {
    RESET_STATE(state) {
      state.screenStatus = new ScreenStatus();
      state.notificationFlags = {
        singIn: false,
        signUp: false,
        resetPassword: false,
        deleteMonitoringTarget: false,
        deleteMonitoringDevice: false,
      };
      state.lastAccessDate = null;
    },
    SCREEN_STATUS_CD(state, screenStatusCd) {
      state.screenStatus = new ScreenStatus(screenStatusCd);
    },
    NOTIFICATION_FLAGS_SIGN_IN(state, val) {
      state.notificationFlags.singIn = val;
    },
    NOTIFICATION_FLAGS_SIGN_UP(state, val) {
      state.notificationFlags.singUp = val;
    },
    NOTIFICATION_FLAGS_RESET_PASSWORD(state, val) {
      state.notificationFlags.resetPassword = val;
    },
    NOTIFICATION_FLAGS_DELETE_MONITORING_TARGET(state, val) {
      state.notificationFlags.deleteMonitoringTarget = val;
    },
    NOTIFICATION_FLAGS_DELETE_MONITORING_DEVICE(state, val) {
      state.notificationFlags.deleteMonitoringDevice = val;
    },
    LAST_ACCESS_DATE(state, val) {
      state.lastAccessDate = val;
    },
  },

  getters: {
    // 画面ステータス
    screenStatus(state) {
      return state.screenStatus.copy();
    },
    lastAccessDate(state) {
      return state.lastAccessDate;
    },
    screenStatusCd(state) {
      return state.screenStatus.statusCd;
    },
    isInitialize(state) {
      return state.screenStatus.statusCd === SCREEEN_STATUS_CD.INITIALIZE;
    },
    isScreenActive(state) {
      return state.screenStatus.statusCd === SCREEEN_STATUS_CD.ACTIVE;
    },
    isScreenLoading(state) {
      return state.screenStatus.statusCd === SCREEEN_STATUS_CD.LOADING;
    },
    // 通知ステータス
    signInNotificationFlag(state) {
      return state.notificationFlags.singIn;
    },
    signUpNotificationFlag(state) {
      return state.notificationFlags.singUp;
    },
    resetPasswordNotificationFlag(state) {
      return state.notificationFlags.resetPassword;
    },
    deleteMonitoringTargetNotificationFlag(state) {
      return state.notificationFlags.deleteMonitoringTarget;
    },
    deleteMonitoringDeviceNotificationFlag(state) {
      return state.notificationFlags.deleteMonitoringDevice;
    },
  },

  actions: {
    resetState({ commit }) {
      commit("RESET_STATE");
    },
    // 画面ステータス更新
    async updateScreenStatusCd({ commit }, screenStatusCd) {
      commit("SCREEN_STATUS_CD", screenStatusCd);
    },

    async getLastAccessDate({ state }) {
      return state.lastAccessDate;
    },
    async updateLastAccessDate({ commit }, lastAccessDate) {
      commit("LAST_ACCESS_DATE", lastAccessDate);
    },
    // 通知ステータス更新
    async updateNotificationFlags({ commit }, val) {
      try {
        commit("NOTIFICATION_FLAGS_SIGN_IN", val);
      } catch (err) {
        // TODO: 発生したエラーを画面に反映
      }
    },
    async updateSignUpNotificationFlag({ commit }, val) {
      try {
        commit("NOTIFICATION_FLAGS_SIGN_UP", val);
      } catch (err) {
        // TODO: 発生したエラーを画面に反映
      }
    },
    async updateResetPasswordNotificationFlag({ commit }, val) {
      try {
        commit("NOTIFICATION_FLAGS_RESET_PASSWORD", val);
      } catch (err) {
        // TODO: 発生したエラーを画面に反映
      }
    },
    async updateDeleteMonitoringTargetNotificationFlag({ commit }, val) {
      try {
        commit("NOTIFICATION_FLAGS_DELETE_MONITORING_TARGET", val);
      } catch (err) {
        // TODO: 発生したエラーを画面に反映
      }
    },
    async updateDeleteMonitoringDeviceNotificationFlag({ commit }, val) {
      try {
        commit("NOTIFICATION_FLAGS_DELETE_MONITORING_DEVICE", val);
      } catch (err) {
        // TODO: 発生したエラーを画面に反映
      }
    },
  },
};
